<template>
  <div class="home">
    <HelloWorld />
    <!-- <HomeStartUp /> -->
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
// import HomeStartUp from "@/components/HomeStartUp.vue";
// import * as firebase from "firebase";
export default {
  name: "home",
  components: {
    HelloWorld
    // HomeStartUp
  },
  created() {
    console.log("Home component created");

    // let currentUser = firebase.auth().currentUser;
    // console.log("currentUser from Home.vue: ", currentUser.uid);
    // firebase
    //   .auth()
    //   .currentUser.getIdTokenResult()
    //   .then(idTokenResult => {
    //     // Confirm the user is an Admin.
    //     if (idTokenResult.claims.admin) {
    //       // Show admin UI.
    //       console.log("user is admin");
    //     } else {
    //       // Show regular user UI.
    //       console.log("user is NOT admin");
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
    // window.document.title = "TAPLAW";
  }
};
</script>
